import { useState, useEffect } from 'react';
import styles from './GerenciamentoPedidosMobile.module.css';
import FooterOpcoes from '../../cliente/components/FooterOpcoes';
import { numeroExibicaoPedido } from '../../../shared/utils/pedido';

function GerenciamentoPedidosMobile() {
  const [pedidos, setPedidos] = useState([]);

  const buscarPedidos = async () => {
    try {
      const API_URL = process.env.REACT_APP_API_URL; // pega a URL do backend do .env
      const token = localStorage.getItem('token');
      const estabelecimentoId = localStorage.getItem('estabelecimento_id');

      const headers = {
        'Content-Type': 'application/json'
      };

      // Adicionar token ao header se existir
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      const resPedidos = await fetch(`${API_URL}/buscapedidos?estabelecimento_id=${estabelecimentoId}`, { headers });
      const dataPedidos = await resPedidos.json();

      const resItens = await fetch(`${API_URL}/buscaitenspedido?estabelecimento_id=${estabelecimentoId}`, { headers });
      const dataItens = await resItens.json();

      const pedidosComItens = dataPedidos.map(pedido => ({
        ...pedido,
        itens: dataItens.filter(item => String(item.id_pedido) === String(pedido.id_pedido))
      }));

      setPedidos(pedidosComItens);
    } catch (error) {
      console.log("Erro ao buscar pedidos:", error);
    }
  };

  useEffect(() => {
    buscarPedidos();
  }, []);

  // Função para mudar o status do pedido
  const mudarStatusPedido = async (numPedido, novoStatus) => {
    try {
      const response = await fetch(`${API_URL}/atualizar-item`, {
        method: "POST",
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token')}` },
        body: JSON.stringify({ numPedido, novoStatus })
      });
      const data = await response.json();
      if (data.success) {
        // Remove o pedido da lista após atualizar
        setPedidos(prev => prev.filter(p => p.id_pedido !== numPedido));
      } else {
        alert("Erro ao atualizar status");
      }
    } catch (error) {
      console.error("Erro de comunicação com o backend:", error);
    }
  };

  return (
    <div className={styles.containerMobile}>
      <header className={styles.header}>
        <h2>📋 Gerenciamento de Pedidos</h2>
        <p>Atualize o status dos pedidos e eles desaparecerão da lista</p>
      </header>

      <div className={styles.listaPedidos}>
        {pedidos.length > 0 ? pedidos.map(pedido => (
          <div key={pedido.id_pedido} className={styles.cardPedido}>
            <div className={styles.infoPedido}>
              <h3>Pedido #{numeroExibicaoPedido(pedido)} - Mesa {pedido.id_mesa}</h3>
              <p>Total: R$ {pedido.total}</p>
            {/*  <div className={styles.itensPedido}>
                {pedido.itens.map(item => (
                  <p key={item.id_item}>• {item.detalhes?.nome_item || item.nome_item} - {item.quantidade}</p>
                ))}
              </div>*/}
            </div>
            <div className={styles.controleStatus}>
              <button onClick={() => mudarStatusPedido(pedido.id_pedido, 'em andamento')}>
                Em andamento
              </button>
              <button onClick={() => mudarStatusPedido(pedido.id_pedido, 'pronto')}>
                Pronto
              </button>
            </div>
          </div>
        )) : (
          <p>Nenhum pedido pendente</p>
        )}
      </div>
      <FooterOpcoes typeView="admin"/>
    </div>
  );
}

export default GerenciamentoPedidosMobile;
